// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "header[data-v-2320d4cd]{position:fixed}@media (min-width:640px){header[data-v-2320d4cd]{position:relative}}.image-container[data-v-2320d4cd]{position:relative;width:16rem;position:relative;padding-bottom:15%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
